import type { ReactNode } from "react";
import { Icon } from "@/components/icons";

export function EmptyInner({
  icon,
  title,
  hint,
  minHeight,
  action,
}: {
  icon: string;
  title: string;
  hint?: string;
  minHeight?: number;
  action?: ReactNode;
}) {
  return (
    <div
      className="flex flex-1 flex-col items-center justify-center gap-3 px-4 py-10 text-center"
      style={minHeight ? { minHeight } : undefined}
    >
      <span className="flex size-10 items-center justify-center rounded-full bg-grey-100 text-grey-500">
        <Icon name={icon} size={20} />
      </span>
      <div className="flex flex-col gap-1">
        <p className="text-small font-medium text-grey-900">{title}</p>
        {hint && <p className="text-small text-grey-600">{hint}</p>}
      </div>
      {action}
    </div>
  );
}
